'use strict';

/* ////////////////////////////////////////////////////////////////////////////// */
/* ///////////////////////////////////////////////////////////////// DOCUMENT /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* -------------------------------------------------------------------- READY --- */
$(init);

/* --------------------------------------------------------------------- INIT --- */
function init() {
	// browser
	browser_init();

	// shopify
	shopify_init();

	/* --- */

	// anchor
	anchor_init();

	// deck
	deck_init();

	// header
	header_init();

	// state
	state_init();

	// video
	video_init();

	/* --- */

	// attribute
	attribute_init();

	// cart
	cart_init();

	// collection
	collection_init();

	// product
	product_init();

	// review
	review_init();

	// voucher
	voucher_init();
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* ////////////////////////////////////////////////////////////////// BROWSER /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function browser_init() {
	// prepare
	browser_prepare();

	// event
	browser_event();

	// viewport
	browser_viewport();
}

/* ------------------------------------------------------------------ PREPARE --- */
function browser_prepare() {
	// remove load class
	setTimeout(function() { $('html').removeClass('browser:load'); }, 50);
}

/* -------------------------------------------------------------------- EVENT --- */
function browser_event() {
	// resize event
	browser_event_resize();
}

/* ----------------------------------------------------------- EVENT : RESIZE --- */
function browser_event_resize() {
	// listen for resize
	$(window).on('resize', function() {
		var timer;

		// destroy timer
		clearTimeout(timer);

		// debounce
		timer = setTimeout(function() {
			// remove resize class
			$('html').removeClass('browser:resize');
		}, 500);

		// add resize class
		$('html').addClass('browser:resize');

		// viewport
		browser_viewport();
	});
}

/* ----------------------------------------------------------------- VIEWPORT --- */
function browser_viewport() {
	var height,
		width;

	// determine viewport unit
	width = ($(window).innerWidth() * (1 / 100));
	height = ($(window).innerHeight() * (1 / 100));

	// viewport unit
	$(':root').css('--viewport-width', `${width}px`);
	$(':root').css('--viewport-height', `${height}px`);
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* //////////////////////////////////////////////////////////////////// TOUCH /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* ----------------------------------------------------------------- POSITION --- */
function touch_position(event) {
	var position,
		touch;

	// touch position
	touch = event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
	// format position
	position = { x: touch.pageX, y: touch.pageY, };

	return position;
}

/* ----------------------------------------------------------------- PROPERTY --- */
function touch_property(a, b) {
	var direction,
		touch;

	// default value
	b = b || a;

	// determine touch direction
	if (Math.abs(b.x - a.x) > Math.abs(b.y - a.y)) {
		if (b.x > a.x) direction = 'right';
		else direction = 'left';
	}
	else if (Math.abs(b.x - a.x) < Math.abs(b.y - a.y)) {
		if (b.y > a.y) direction = 'down';
		else direction = 'up';
	}

	// touch properties
	touch = { direction: direction, };

	return touch;
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* ////////////////////////////////////////////////////////////////// SHOPIFY /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function shopify_init() {
	// prepare
	shopify_prepare();
}

/* ------------------------------------------------------------------ PREPARE --- */
function shopify_prepare() {
	// process sections
	$('.shopify-section').each(function() {
		var $section;

		// cache element
		$section = $(this);

		// section unwrap
		shopify_section_unwrap($section);
	});
}

/* --------------------------------------------------------- SECTION : UNWRAP --- */
function shopify_section_unwrap(section) {
	var $section;

	// cache element
	$section = $(section);

	// unwrap section contents
	$section.contents().unwrap();
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* /////////////////////////////////////////////////////////////////// ANCHOR /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function anchor_init() {
	// prepare
	anchor_prepare();

	// event
	anchor_event();
}

/* ------------------------------------------------------------------ PREPARE --- */
function anchor_prepare() {
	var key;

	// anchor key
	key = location.hash.substring(1);

	// scroll
	setTimeout(function() { anchor_scroll(key); }, 100);
}

/* -------------------------------------------------------------------- EVENT --- */
function anchor_event() {
	// event click
	anchor_event_click();
}

/* ------------------------------------------------------------ EVENT : CLICK --- */
function anchor_event_click() {
	// listen for click
	$('a[href^="#"]').on('click', function() {
		var $a;
		var key;

		// cache element
		$a = $(this);

		// anchor key
		key = $a.attr('href').substring(1);

		// scroll
		anchor_scroll(key);
	});
}

/* ------------------------------------------------------------------- SCROLL --- */
function anchor_scroll(key) {
	var $anchor;
	var offset;

	// validate key
	if (key === '') return;

	// cache element
	$anchor = $(`a.anchor[data-anchor-key="${key}"]`);

	// validate anchor exists
	if ($anchor.length === 0) return;

	// anchor offset
	offset = $anchor.offset().top;

	// scroll to anchor
	$('html, body').animate({ scrollTop: offset, }, 400);
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// DECK /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function deck_init() {
	// validate deck
	if ($('.deck').length === 0) return;

	// prepare
	deck_prepare();

	// event
	deck_event();
}

/* ------------------------------------------------------------------ PREPARE --- */
function deck_prepare() {
	// process decks
	$('.deck').each(function() {
		var $deck;
		var total;

		// cache element
		$deck = $(this);

		// deck total
		total = $deck.find('.card').length;
		$deck.find('.count span.total').text(total);

		// change
		deck_change($deck, 0);
	});
}

/* -------------------------------------------------------------------- EVENT --- */
function deck_event() {
	// event click
	deck_event_click();

	// event touch
	deck_event_touch();
}

/* ------------------------------------------------------------ EVENT : CLICK --- */
function deck_event_click() {
	// listen for click
	$('.deck nav.control a').on('click', function() {
		var $deck,
			$a;
		var action;

		// cache elements
		$a = $(this);
		$deck = $a.closest('.deck');

		// determine action
		if ($a.is('.prev')) action = 'prev';
		else if ($a.is('.next')) action = 'next';

		// action
		deck_action($deck, action);
	});
}

/* ------------------------------------------------------------ EVENT : TOUCH --- */
function deck_event_touch() {
	var touch;

	// listen for touchstart
	$('.deck').on('touchstart', function(event) {
		// reset touch
		touch = {};

		// position
		touch.a = touch_position(event);
	});

	// listen for touchmove
	$('.deck').on('touchmove', function(event) {
		var $deck;
		var action;

		// cache element
		$deck = $(this);

		// validate start position
		if (typeof touch.a === 'undefined') return;

		// position
		touch.b = touch_position(event);

		// validate threshold reached
		if (Math.abs(touch.a.x - touch.b.x) < 96) return;

		// determine touch properties
		touch = $.extend(touch, touch_property(touch.a, touch.b));

		// left
		if (touch.direction === 'left') action = 'prev';
		// right
		else if (touch.direction === 'right') action = 'next';

		// action
		deck_action($deck, action);

		// reset touch
		touch = {};
	});
}

/* ------------------------------------------------------------------- ACTION --- */
function deck_action(deck, action) {
	var $deck;
	var index,
		total;

	// cache element
	$deck = $(deck);

	// deck state
	index = $deck.find('.card.display').index();
	total = $deck.find('.card').length;

	// determine index
	if (action === 'prev') index--;
	else if (action === 'next') index++;

	// bound index
	if (index < 0) index = (total - 1);
	else if (index > (total - 1)) index = 0;

	// change
	deck_change($deck, index);
}

/* ------------------------------------------------------------------- CHANGE --- */
function deck_change(deck, index) {
	var $video,
		$deck,
		$card;

	// cache elements
	$deck = $(deck);
	$card = $deck.find('.card').eq(index);
	$video = $card.find('.video');

	// deck video pause
	$deck.find('.video').each(function() { video_pause($(this)); });

	// deck index
	$deck.find('.count span.index').text((index + 1));

	// toggle display class
	$deck.find('.card').removeClass('display');
	$card.addClass('display');

	// validate video
	if ($video.length !== 0) {
		// video
		video_play($video);
	}
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* /////////////////////////////////////////////////////////////////// HEADER /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function header_init() {
	// validate header
	if ($('header').length === 0) return;

	// event
	header_event();

	// prepare
	header_prepare();
}

/* ------------------------------------------------------------------ PREPARE --- */
function header_prepare() {
	// collection height
	header_collection_height();
}

/* -------------------------------------------------------------------- EVENT --- */
function header_event() {
	// event click
	header_event_click();

	// event resize
	header_event_resize();
}

/* ------------------------------------------------------------ EVENT : CLICK --- */
function header_event_click() {
	// listen for click
	$(' header a.toggle').on('click', function() {
		// toggle active class
		$('html').toggleClass('nav:active');
	});

	// listen for click
	$('header nav.menu button').on('click', function() {
		// toggle active class
		$('html').toggleClass('collection:active');

		// timer
		state_timer();
	});
}

/* ----------------------------------------------------------- EVENT : RESIZE --- */
function header_event_resize() {
	// listen for resize
	$(window).on('resize', function() {
		// collection height
		header_collection_height();
	});
}

/* ------------------------------------------------------ COLLECTION : HEIGHT --- */
function header_collection_height() {
	var $collection;
	var height;

	// cache element
	$collection = $('header nav.collection');

	// remove ready class
	$collection.removeClass('ready');

	// determine height
	height = $collection.outerHeight();

	// collection height
	$(':root').css('--collection-height', `${height}px`);

	// add ready class
	$collection.addClass('ready');
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* //////////////////////////////////////////////////////////////////// STATE /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function state_init() {
	// event
	state_event();
}

/* -------------------------------------------------------------------- EVENT --- */
function state_event() {
	// event mouse
    header_event_mouse();

	// event scroll
	state_event_scroll();
}

/* ------------------------------------------------------------ EVENT : MOUSE --- */
function header_event_mouse() {
	// listen for mousemove
    $('header').on('mousemove', function() {
		// timer
		state_timer();
	});
}

/* ----------------------------------------------------------- EVENT : SCROLL --- */
function state_event_scroll() {
	var scroll = {};
	
	// listen for scroll
	$(window).on('scroll', function() {
		// current scroll
        scroll.current = $(window).scrollTop();

		// validate scroll change
        if (scroll.current < scroll.last) {
			// timer
			state_timer();
		} 

		// last scroll
        scroll.last = scroll.current;
	});
}

/* -------------------------------------------------------------------- TIMER --- */
function state_timer() {
	var timer;

	// retrieve timer
	timer = $(document).data('timer');
	// destroy timer
	clearTimeout(timer);

	// remove state class
	$('html').removeClass('state:idle');

	// validate collection active
	if ($('html').is('.collection\\:active')) return;

	// timer to detect idle state
	timer = setTimeout(function() {
		// add state class
		$('html').addClass('state:idle');
	}, 3500);

	// store timer
	$(document).data('timer', timer);
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* //////////////////////////////////////////////////////////////////// VIDEO /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function video_init() {
	// validate video
	if ($('.video').length === 0) return;

	// youtube ready
	window.onYouTubeIframeAPIReady = function() {
		// prepare
		video_prepare();

		// event
		video_event();
	};
}

/* ------------------------------------------------------------------ PREPARE --- */
function video_prepare() {
	// process videos
	$('.video').each(function() {
		var $video;
		var source,
			url;

		// cache element
		$video = $(this);

		// video url
		url = $video.attr('data-video-url');

		// determine source
		source = new URL(url).host;

		// vimeo source
		if (source.includes('vimeo')) source = 'vimeo';
		// youtube source
		else if (source.includes('youtube')) source = 'youtube';
		// native
		else source = 'native';

		// video source
		$video.attr('data-video-source', source);
	});
}

/* -------------------------------------------------------------------- EVENT --- */
function video_event() {
	// event click
	video_event_click();
}

/* ------------------------------------------------------------ EVENT : CLICK --- */
function video_event_click() {
	// listen for click
	$('.video').on('click', function() {
		var $video;

		// cache element
		$video = $(this);

		// validate video state
		if (!$video.is('.active')) {
			// play
			video_play($video);
		}
		// pause
		else video_pause($video);
	});
}

/* --------------------------------------------------------------------- PLAY --- */
function video_play(video) {
	// promise
	return new Promise(async function(resolve) {
		var $video;
		var source,
			config;

		// cache element
		$video = $(video);

		// validate load/active
		if ($video.is('.load, .active')) return resolve();

		// add load class
		$video.addClass('load');

		// video properties
		source = $video.attr('data-video-source');
		try { config = JSON.parse($video.attr('data-video-config')); } catch { config = {}; }

		// validate source
		if (typeof source === 'undefined') return resolve();

		// play
		await window[`video_${source}_play`]($video, config);

		// resolve
		return resolve();
	});
}

/* -------------------------------------------------------------------- PAUSE --- */
function video_pause(video) {
	// promise
	return new Promise(async function(resolve) {
		var $video;
		var source;

		// cache element
		$video = $(video);

		// validate active
		if (!$video.is('.active')) return resolve();

		// video source
		source = $video.attr('data-video-source');

		// validate source
		if (typeof source === 'undefined') return resolve();

		// pause
		await window[`video_${source}_pause`]($video);

		// resolve
		return resolve();
	});
}

/* ------------------------------------------------------------- VIMEO : PLAY --- */
function video_vimeo_play(video, config) {
	// promise
	return new Promise(async function(resolve) {
		var $video;
		var player;

		// cache element
		$video = $(video);

		// initalize player
		player = await video_vimeo_player($video, config);

		// listen for playing
		player.on('playing', function handler() {
			// remove event listener
			player.off('playing', handler);

			// resolve
			return resolve();
		});

		// trigger play
		player.play();
	});
}

/* ----------------------------------------------------------- VIMEO : PLAYER --- */
function video_vimeo_player(video, config) {
	// promise
	return new Promise(function(resolve) {
		var $video;
		var player,
			param,
			url;

		// cache elements
		$video = $(video);

		// retrieve player
		player = $video.data('player');

		// validate existing player
		if (typeof player !== 'undefined') return resolve(player);

		// video url
		url = $video.attr('data-video-url');

		// default
		param = {
			autopause: false,
			background: false,
			byline: false,
			controls: true,
			loop: false,
			muted: false,
			playsinline: true,
			title: false,
			url: url,
		};

		// background
		if (config.background) {
			param.controls = false;
			param.loop = true;
			param.muted = true;
		}

		// initalize player
		player = new Vimeo.Player($video, param);

		// listen for ready
		player.ready().then(function() {
			// add ready class
			$video.addClass('ready');

			// store player
			$video.data('player', player);

			// resolve
			return resolve(player);
		});

		// listen for playing
		player.on('playing', function() {
			// toggle load/active classes
			setTimeout(function() { $video.removeClass('load').addClass('active'); }, 50);
		});

		// listen for pause
		player.on('pause', function() {
			// remove load/active class
			$video.removeClass('load active');
		});
	});
}

/* ------------------------------------------------------------ VIMEO : PAUSE --- */
function video_vimeo_pause(video) {
	// promise
	return new Promise(async function(resolve) {
		var $video;
		var player;

		// cache element
		$video = $(video);

		// initalize player
		player = await video_vimeo_player($video);

		// listen for pause
		player.on('pause', function handler() {
			// remove event listener
			player.off('pause', handler);

			// resolve
			return resolve();
		});

		// trigger pause
		player.pause();
	});
}

/* --------------------------------------------------------- YOUTUBE : PLAYER --- */
function video_youtube_player(video, config) {
	// promise
	return new Promise(function(resolve) {
		var $parent,
			$video;
		var player,
			param,
			url,
			id;

		// cache elements
		$video = $(video);

		// retrieve player
		player = $video.data('player');

		// existing player
		if (typeof player !== 'undefined') return resolve(player);

		// video properties
		url = $video.attr('data-video-url');
		id = new URLSearchParams(new URL(url).search).get('v');

		// build parent element
		$parent = $('<div>');
		$video.append($parent);

		// default
		param = {
			controls: 1,
			disablekb: 1,
			loop: 0,
			modestbranding: 1,
			noCookie: 1,
			playsinline: 1,
			rel: 0,
		};

		// background
		if (config.background) {
			param.controls = 0;
			param.loop = 1;
			param.muted = 1;
			param.playlist = id;
		}

		// initalize player
		player = new YT.Player($parent[0], {
			playerVars: param,
			videoId: id,
		});

		// listen for onReady
		player.addEventListener('onReady', function() {
			// background
			if (config.background) player.mute();

			// add ready class
			$video.addClass('ready');

			// store player
			$video.data('player', player);

			// resolve
			return resolve(player);
		});

		// listen for onStateChange
		player.addEventListener('onStateChange', function(event) {
			// event
			switch (event.data) {
				// playing
				case YT.PlayerState.PLAYING:
					// toggle load/active classes
					setTimeout(function() { $video.removeClass('load').addClass('active'); }, 50);
					break;
				// paused
				case YT.PlayerState.PAUSED:
					// remove load/active class
					$video.removeClass('load active');
					break;
			}
		});
	});
}

/* ----------------------------------------------------------- YOUTUBE : PLAY --- */
function video_youtube_play(video, config) {
	// promise
	return new Promise(async function(resolve) {
		var $video;
		var player;

		// cache element
		$video = $(video);

		// initalize player
		player = await video_youtube_player($video, config);

		// listen for onStateChange
		player.addEventListener('onStateChange', function handler(event) {
			// validate event
			if (event.data !== YT.PlayerState.PLAYING) return;

			// remove event listener
			player.removeEventListener('onStateChange', handler);

			// resolve
			return resolve();
		});

		// trigger play
		player.playVideo();
	});
}

/* ---------------------------------------------------------- YOUTUBE : PAUSE --- */
function video_youtube_pause(video) {
	// promise
	return new Promise(async function(resolve) {
		var $video;
		var player;

		// cache element
		$video = $(video);

		// initalize player
		player = await video_youtube_player($video);

		// listen for onStateChange
		player.addEventListener('onStateChange', function handler(event) {
			// validate event
			if (event.data !== YT.PlayerState.PAUSED) return;

			// remove event listener
			player.removeEventListener('onStateChange', handler);

			// resolve
			return resolve();
		});

		// trigger play
		player.playVideo();
	});
}

/* ------------------------------------------------------------ NATIVE : PLAY --- */
function video_native_play(video, config) {
	// promise
	return new Promise(async function(resolve) {
		var $video;
		var player;

		// cache element
		$video = $(video);

		// initalize player
		player = await video_native_player($video, config);

		// listen for playing
		player.addEventListener('playing', function handler() {
			// remove event listener
			player.removeEventListener('playing', handler);

			// resolve
			return resolve();
		});

		// trigger play
		player.play();
	});
}

/* ---------------------------------------------------------- NATIVE : PLAYER --- */
function video_native_player(video, config) {
	// promise
	return new Promise(function(resolve) {
		var $video;
		var player,
			param,
			url;

		// cache elements
		$video = $(video);

		// retrieve player
		player = $video.data('player');

		// validate existing player
		if (typeof player !== 'undefined') return resolve(player);

		// video url
		url = $video.attr('data-video-url');

		// build player element
		player = $('<video>')[0];
		$video.append(player);

		// default
		param = {
			autoplay: false,
			controls: true,
			loop: false,
			muted: false,
			playsinline: true,
			src: url,
		};

		// background
		if (config.background) {
			param.controls = false;
			param.loop = true;
			param.muted = true;
		}

		// initalize player
		param = Object.fromEntries(Object.entries(param).filter(function(_, value) { return value !== false; }));
		$(player).attr(param);

		// listen for ready
		setTimeout(function() {
			// add ready class
			$video.addClass('ready');

			// store player
			$video.data('player', player);

			// resolve
			return resolve(player);
		}, 100);

		// listen for playing
		player.addEventListener('playing', function() {
			// toggle load/active classes
			setTimeout(function() { $video.removeClass('load').addClass('active'); }, 50);
		});

		// listen for pause
		player.addEventListener('pause', function() {
			// remove load/active class
			$video.removeClass('load active');
		});


	});
}

/* ----------------------------------------------------------- NATIVE : PAUSE --- */
function video_native_pause(video) {
	// promise
	return new Promise(async function(resolve) {
		var $video;
		var player;

		// cache element
		$video = $(video);

		// initalize player
		player = await video_native_player($video);

		// listen for pause
		player.addEventListener('pause', function handler() {
			// remove event listener
			player.removeEventListener('pause', handler);

			// resolve
			return resolve();
		});

		// trigger pause
		player.pause();
	});
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* //////////////////////////////////////////////////////////////// ATTRIBUTE /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function attribute_init() {
	// validate attribute
	if ($('section.attribute').length === 0) return;

	// prepare
	attribute_prepare();

	// event
	attribute_event();
}

/* ------------------------------------------------------------------ PREPARE --- */
function attribute_prepare() {
	// process attributes
	$('section.attribute').each(function() {
		var $attribute;
		var key;

		// cache element
		$attribute = $(this);

		// attribute key
		key = $attribute.find('nav.switch a').first().attr('data-attribute-key');

		// change
		attribute_change($attribute, key);
	});
}

/* -------------------------------------------------------------------- EVENT --- */
function attribute_event() {
	// event click
	attribute_event_click();
}

/* ------------------------------------------------------------ EVENT : CLICK --- */
function attribute_event_click() {
	// listen for click
	$('section.attribute nav.switch a').on('click', function() {
		var $attribute,
			$anchor;
		var key;

		// cache element
		$anchor = $(this);
		$attribute = $anchor.closest('section.attribute');

		// attribute key
		key = $anchor.attr('data-attribute-key');

		// change
		attribute_change($attribute, key);
	});
}

/* ------------------------------------------------------------------- CHANGE --- */
function attribute_change(attribute, key) {
	var $attribute,
		$switch;

	// cache elements
	$attribute = $(attribute);
	$switch = $attribute.find('nav.switch');

	// toggle active class
	$switch.find('a').removeClass('active');
	$switch.find(`a[data-attribute-key="${key}"]`).addClass('active');

	// toggle display class
	$attribute.find('.content').removeClass('display');
	$attribute.find(`.content[data-attribute-key="${key}"]`).addClass('display');

}


/* ////////////////////////////////////////////////////////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// CART /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function cart_init() {
	// validate cart
	if ($('form.cart').length === 0) return;

	// event
	cart_event();
}

/* -------------------------------------------------------------------- EVENT --- */
function cart_event() {
	// event input
	cart_event_input();

	// event click
	cart_event_click();
}

/* ------------------------------------------------------------ EVENT : INPUT --- */
function cart_event_input() {
	// listen for input
	$('form.cart .quantity select').on('input', function() {
		var $select,
			$item;
		var quantity;

		// cache elements
		$select = $(this);
		$item = $select.closest('.row.item');

		// quantity value
		quantity = parseInt($select.val());

		// item quantity
		cart_item_quantity($item, quantity);
	});
}

/* ------------------------------------------------------------ EVENT : CLICK --- */
function cart_event_click() {
	// listen for click
	$('form.cart .quantity button').on('click', function() {
		var $button,
			$item;

		// cache elements
		$button = $(this);
		$item = $button.closest('.row.item');

		// item quantity
		cart_item_quantity($item, 0);
	});
}

/* ---------------------------------------------------------- ITEM : QUANTITY --- */
function cart_item_quantity(item, quantity) {
	// promise
	(async function() {
		var $item;
		var data = {};

		// cache element
		$item = $(item);

		// build data
		data.line = $item.index();
		data.quantity = quantity;

		// request cart update
		try { await $.post(window.Shopify.routes.cart_change_url, data); } catch { }

		// reload
		location.reload();
	})();
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* /////////////////////////////////////////////////////////////// COLLECTION /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function collection_init() {
	// validate collection
	if ($('html.template\\:collection\\:set').length === 0) return;

	// prepare
	collection_prepare();

	// event
	collection_event();
}

/* ------------------------------------------------------------------ PREPARE --- */
function collection_prepare() {
	// process collections
	$('section.collection').each(function() {
		var $collection,
			$article;
		var key;

		// cache elements
		$collection = $(this);
		$article = $collection.find('article').first();

		// collection key
		key = $article.attr('data-collection-key');

		// picture change
		collection_picture_change($collection, key);
	});
}

/* -------------------------------------------------------------------- EVENT --- */
function collection_event() {
	// event mouse
	collection_event_mouse();
}

/* ------------------------------------------------------------ EVENT : MOUSE --- */
function collection_event_mouse() {
	// listen for mouseenter
	$('section.collection article').on('mouseenter', function() {
		var $collection,
			$article;
		var key;

		// cache elements
		$article = $(this);
		$collection = $article.closest('section.collection');

		// collection key
		key = $article.attr('data-collection-key');

		// picture change
		collection_picture_change($collection, key);
	});
}

/* --------------------------------------------------------- PICTURE : CHANGE --- */
function collection_picture_change(collection, key) {
	var $collection;

	// cache element
	$collection = $(collection);

	// toggle display class
	$collection.find('.picture').removeClass('display')
	$collection.find(`.picture[data-collection-key="${key}"]`).addClass('display');
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* ////////////////////////////////////////////////////////////////// PRODUCT /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function product_init() {
	// validate product
	if ($('form.product').length === 0) return;

	// prepare
	product_prepare();

	// event
	product_event();
}

/* ------------------------------------------------------------------ PREPARE --- */
function product_prepare() {
	// checkout validate
	product_checkout_validate();
}

/* -------------------------------------------------------------------- EVENT --- */
function product_event() {
	// event input
	product_event_input();
}

/* ------------------------------------------------------------ EVENT : INPUT --- */
function product_event_input() {
	// listen for input
	$('form.product [name*="options"]').on('input', function() {
		// variant update
		product_variant_update();
		// checkout validate
		product_checkout_validate();
	});

	// listen for input
	$('form.product .agreement input').on('input', function() {
		// checkout validate
		product_checkout_validate();
	});
}

/* ----------------------------------------------------------- VARIANT : DATA --- */
function product_variant_data() {
	var $product,
		$data;
	var product,
		variant,
		option = [];

	// cache elements
	$product = $('form.product');
	$data = $product.find('.checkout .data');

	// validate options
	if ($product.find('[name*="options"]').length === 0) return;

	// parse product json
	product = JSON.parse($data.find('script').html() || '{}');

	// validate product json
	if (Object.keys(product).length === 0) return;

	// process options
	$product.find('[name*="options"]').each(function() {
		var $input;
		var value,
			type;

		// cache element
		$input = $(this);

		// validate input
		if ($input.length === 0) return;

		// input properties
		type = $input.attr('type');
		value = $input.val();

		// validate radio
		if (type === 'radio' && !$input.is(':checked')) return;

		// option value
		option.push(value);
	});

	// determine variant from options
	variant = product.variants.find(function(variant) {
		return JSON.stringify(variant.options) === JSON.stringify(option);
	});

	return variant;
}

/* --------------------------------------------------------- VARIANT : UPDATE --- */
function product_variant_update() {
	var $checkout,
		$product,
		$data;
	var variant,
		price;

	// cache elements
	$product = $('form.product');
	$checkout = $product.find('.checkout');
	$data = $checkout.find('.data');

	// reset agreement
	$product.find('.agreement input').prop('checked', false);

	// variant data
	variant = product_variant_data();

	// validate variant
	if (typeof variant === 'undefined') return;

	// update active variant
	$data.find('[name="id"]').val(variant.id);

	// variant price
	price = $data.find(`[name="id"] [value="${variant.id}"]`).attr('data-variant-price');
	// render variant price
	$checkout.find('.price').text(price);
}

/* -------------------------------------------------------- CHECKOUT : TOGGLE --- */
function product_checkout_validate() {
	var $agreement,
		$checkout,
		$product;
	var variant;

	// cache elements
	$product = $('form.product');
	$agreement = $product.find('.agreement');
	$checkout = $product.find('.checkout');

	// add disabled class
	$checkout.addClass('disabled');

	// variant data
	variant = product_variant_data();

	// validate variant
	if (typeof variant === 'undefined') return;
	// validate variant availability
	if (!variant.available) return;

	// validate agreement
	if ($agreement.length !== 0 && !$agreement.find('input').is(':checked')) return;

	// remove disabled class
	$checkout.removeClass('disabled');
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* /////////////////////////////////////////////////////////////////// REVIEW /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function review_init() {
	// validate review
	if ($('section.review').length === 0) return;

	// async
	(async function() {
		// prepare
		await review_prepare();

		// event
		review_event();

		// metadata
		review_metadata();

		// list request
		review_list_request();
	})();
}

/* ------------------------------------------------------------------ PREPARE --- */
function review_prepare() {
	// promise
	return new Promise(async function(resolve) {
		var $review;
		var product = {},
			result;

		// cache element
		$review = $('section.review');

		// product id
		product.id = $review.attr('data-product-id');
		// request
		try { result = await review_request('get', `/product/${product.id}`); } catch {
			return;
		}

		// review id
		$review.attr('data-review-id', result.product.id);

		// add active class
		$review.addClass('active');

		// resolve
		return resolve();
	});
}

/* -------------------------------------------------------------------- EVENT --- */
function review_event() {
	// event click
	review_event_click();
}

/* ------------------------------------------------------------ EVENT : CLICK --- */
function review_event_click() {
	var $review;

	// cache element
	$review = $('section.review');

	// listen for click
	$review.find('.list nav.pagination a').on('click', async function() {
		var $a;
		var page;

		// cache element
		$a = $(this);

		// current page
		page = Number($review.attr('data-review-page'));

		// determine action
		if ($a.is('.prev')) page--;
		else if ($a.is('.next')) page++;

		// list request
		await review_list_request(page);

		// scroll
		anchor_scroll('review');
	});
}

/* ----------------------------------------------------------------- METADATA --- */
function review_metadata() {
	// async
	(async function() {
		var $review;
		var review = {},
			result;

		// cache element
		$review = $('section.review');

		// review id
		review.id = $review.attr('data-review-id');
		// request
		result = await review_request('get', `/product/${review.id}/review/count`);

		// quality
		review_quality(result);

		// histogram
		review_histogram(result);
	})();
}

/* ------------------------------------------------------------------ QUALITY --- */
function review_quality(result) {
	var $quality,
		$count,
		$score;
	var count,
		score = 0;

	// cache elements
	$quality = $('form.product .subject, section.review .overview').find('.quality');
	$count = $quality.find('.count');
	$score = $quality.find('.score');

	// total count
	count = result.count.total;

	// total count data
	$count.text(count);
	// add singular class
	if (count === 1) $count.addClass('singular');

	// calculate sum of scores
	for (var a = 0; a < 5; a++) {
		var index;

		// score index
		index = (a + 1);
		// update score
		score = (score + (index * result.count[index]));
	}
	// calculate score average
	score = Math.round((score / count));

	// add active class
	$score.each(function() { $(this).find('span').slice(0, score).addClass('active'); });
}

/* ---------------------------------------------------------------- HISTOGRAM --- */
function review_histogram(result) {
	var $histogram;

	// cache element
	$histogram = $('section.review .histogram');

	// process items
	$histogram.find('.item').each(function() {
		var $count,
			$item;
		var index,
			count;

		// cache elements
		$item = $(this);
		$count = $item.find('.count');

		// score index
		index = (5 - $item.index());
		// score count
		count = result.count[index];

		// count data
		$count.text(count);
		// add singular class
		if (count === 1) $count.addClass('singular');

		// score delta
		$item.find('.meter').css('--delta', (count / result.count.total));
	});
}

/* ----------------------------------------------------------- LIST : REQUEST --- */
function review_list_request(page) {
	// promise
	return new Promise(async function(resolve) {
		var $review;
		var payload = {},
			review = {},
			result;

		// cache element
		$review = $('section.review');

		// request payload
		payload.page = page;
		payload.limit = 5;

		// review id
		review.id = $review.attr('data-review-id');
		// request
		result = await review_request('get', `/product/${review.id}/review`, payload);

		// list render
		review_list_render(result);

		// resolve
		return resolve();
	});
}

/* ------------------------------------------------------------ LIST : RENDER --- */
function review_list_render(result) {
	var $pagination,
		$review,
		$clone,
		$list;

	// cache elements
	$review = $('section.review');
	$list = $review.find('.list');
	$clone = $list.find('.item.clone');
	$pagination = $list.find('nav.pagination');

	// validate results
	if (result.pagination.page === 1 && result.review.length === 0) {
		// remove list
		return $list.remove();
	}

	// add disabled class
	$pagination.find('a').addClass('disabled');

	// remove list items
	$list.find('.item').not('.clone').remove();

	// process review results
	for (var a = 0; a < result.review.length; a++) {
		var $item;
		var review;

		// cache element
		$item = $clone.clone().removeClass('clone');

		// review data
		review = result.review[a];

		// name
		$item.find('.name').text(review.name);
		// time
		$item.find('time').text(review.time);
		// score
		$item.find('.quality .score span').slice(0, review.score).addClass('active');
		// title
		$item.find('.title').text(review.title);
		// text
		$item.find('.text').text(review.text);
		// purchase
		if (review.purchase) $item.addClass('purchase');

		// append
		$clone.before($item);
	}

	// review page
	$review.attr('data-review-page', result.pagination.page);

	// validate page bounds
	if (result.pagination.page > 1) {
		// remove disabled class
		$pagination.find('a.prev').removeClass('disabled');
	}
	// validate limit bounds
	if (result.review.length === result.pagination.limit) {
		// remove disabled class
		$pagination.find('a.next').removeClass('disabled');
	}
}

/* ------------------------------------------------------------------ REQUEST --- */
function review_request(method, endpoint, payload) {
	// promise
	return new Promise(async function(resolve, reject) {
		var response,
			request;

		// trim leading slash
		endpoint = endpoint.replace(/^\/+/, '');

		// build request
		request = {
			method: method,
			url: `https://pub.thisismyengine.com/caley/${endpoint}`,
			contentType: false,
			dataType: 'json',
			data: payload,
		};
		// perform request
		try { response = await $.ajax(request); } catch {
			// reject
			return reject();
		}

		// resolve
		return resolve(response);
	});
}


/* ////////////////////////////////////////////////////////////////////////////// */
/* ////////////////////////////////////////////////////////////////// VOUCHER /// */
/* ////////////////////////////////////////////////////////////////////////////// */

/* --------------------------------------------------------------------- INIT --- */
function voucher_init() {
	// validate voucher
	if ($('section.voucher').length === 0) return;

	// event
	voucher_event();

	// qr
	voucher_qr();
}

/* -------------------------------------------------------------------- EVENT --- */
function voucher_event() {
	// click event
	voucher_event_click();
}

/* ------------------------------------------------------------ EVENT : CLICK --- */
function voucher_event_click() {
	// listen for click
	$('section.voucher .metadata button.copy').on('click', function() {
		var $metadata,
			$button,
			$input;
		var code;

		// cache elements
		$button = $(this);
		$metadata = $button.closest('.metadata');

		// voucher code
		code = $metadata.find('.code').text();

		// legacy
		if (typeof navigator.clipboard === 'undefined') {
			// build input
			$input = $('<input>');
			// append to metadata
			$metadata.append($input);
			// set copy value
			$input.val(code);
			// focus and select
			$input.focus().select();
			// execute command
			document.execCommand('copy');
			// remove input
			$input.remove();
		}
		// clipboard
		else navigator.clipboard.writeText(code);

		// add active class
		$button.addClass('active');
	});

	// listen for click
	$('section.voucher .action button.print').on('click', function() {
		// print
		window.print();
	});
}

/* ----------------------------------------------------------------------- QR --- */
function voucher_qr() {
	var $qr;
	var identifier,
		height,
		width;

	// cache element
	$qr = $('section.voucher .metadata .qr');

	// qr identifier
	identifier = $qr.attr('data-qr-identifier');

	// qr dimensions
	width = ($qr.width() * 2);
	height = ($qr.height() * 2);

	// initialize qr
	new QRCode($qr[0], {
		text: identifier,
		width: width,
		height: height,
		colorDark: '#ebebeb',
		colorLight: '#343432',
	});
}
